export { default } from './CardActionArea';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/CardActionArea/index.js
// module id = 313
// module chunks = 0